import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const CheckmarkCircleIcon: FC<{
	className?: string
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 46 46"
			fill="none"
			className={props.className}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<rect x="3" y="3" width="40" height="40" rx="20" fill="#D1FADF" />
			<g clipPath="url(#clip0_5772_117541)">
				<path
					d="M31.33 22.23V23C31.33 24.8 30.75 26.55 29.67 27.98C28.6 29.42 27.09 30.48 25.36 30.99C23.64 31.5 21.8 31.43 20.11 30.81C18.43 30.19 16.99 29.04 16.01 27.53C15.03 26.02 14.57 24.24 14.68 22.45C14.8 20.65 15.5 18.95 16.67 17.58C17.83 16.21 19.41 15.26 21.16 14.87C22.92 14.47 24.75 14.65 26.39 15.38M31.33 16.33L23 24.68L20.5 22.18"
					stroke="#039855"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<rect x="3" y="3" width="40" height="40" rx="20" stroke="#ECFDF3" strokeWidth="6" />
			<defs>
				<clipPath id="clip0_5772_117541">
					<rect width="20" height="20" fill="white" transform="translate(13 13)" />
				</clipPath>
			</defs>
		</svg>
	)
}

export default CheckmarkCircleIcon
